import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { fireStore } from "../../firebaseConfig";
import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import "react-datepicker/dist/react-datepicker.css";
import { CgClose } from "react-icons/cg";
import { FiAlertOctagon } from "react-icons/fi";

const Territories = () => {
  const [territories, setTerritories] = useState([]);
  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [warning, setWarning] = useState(false);
  const [delDocIndex, setDelDocIndex] = useState(0);
  const [password, setPassword] = useState("");
  const startDatePickerRef = useRef(null);
  const endDatePickerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (startDatePickerRef.current) {
        adjustDatePickerPosition(startDatePickerRef.current);
      }
      if (endDatePickerRef.current) {
        adjustDatePickerPosition(endDatePickerRef.current);
      }
    };

    const debounceResize = debounce(handleResize, 100);
    window.addEventListener("resize", debounceResize);

    return () => window.removeEventListener("resize", debounceResize);
  }, []);

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const adjustDatePickerPosition = (pickerRef) => {
    const rect = pickerRef.getBoundingClientRect();
    if (rect.right > window.innerWidth) {
      pickerRef.style.left = "auto";
      pickerRef.style.right = "0";
    }
    if (rect.left < 0) {
      pickerRef.style.left = "0";
      pickerRef.style.right = "auto";
    }
  };

  useEffect(() => {
    const fetchterritories = async () => {
      try {
        const collectionRef = collection(fireStore, "Territories");
        const querySnapshot = await getDocs(collectionRef);

        const territoriesList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        territoriesList.sort((a, b) => {
          if (a.zone < b.zone) return -1;
          if (a.zone > b.zone) return 1;
          // If zones are the same, sort by name
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });

        setTerritories(territoriesList);
      } catch (error) {
        console.error("Error fetching territories:", error);
      }
    };

    fetchterritories();
  }, []);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredTerritory = territories.filter((territory) => {
    const matchesSearch = territory.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    return matchesSearch;
  });

  async function deleteTerritory() {
    const savedPass = sessionStorage.getItem("PASSWORD");
    if (savedPass !== password) {
      setWarning(false);
      setDelDocIndex(null);
      return;
    }

    try {
      // Ensure index is valid and territory exists
      const ID = territories[delDocIndex]?.id;
      const NAME = territories[delDocIndex]?.name;
      if (!ID) {
        console.error("Invalid index or ID not found.");
        return;
      }

      // Reference to the document to delete
      const collectionRef = collection(fireStore, "Territories");
      const docRef = doc(collectionRef, ID);

      // Delete the document
      await deleteDoc(docRef);
      setWarning(false);
      setDelDocIndex(null);
      alert(`Territory ${NAME} deleted successfully.`);

      // Update the state to remove the deleted territory
      setTerritories((prevTerritories) =>
        prevTerritories.filter((terry) => terry.id !== ID)
      );

      console.log("Updated territories:");
    } catch (error) {
      setWarning(false);
      setDelDocIndex(null);
    }
  }

  return (
    <div className="p-8 bg-lightgray ">
      {/* warning... */}
      {warning && (
        <div className="flex flex-col justify-center p-2 items-center w-[500px] h-[200px] bg-red-600 absolute top-[35%] left-[35%]">
          <div
            className=" self-end cursor-pointer"
            onClick={() => {
              setWarning(false);
              setPassword("");
              setDelDocIndex(null);
            }}
          >
            <CgClose />
          </div>
          <FiAlertOctagon />

          <h1 className=" font-bold text-lg px-8">
            You are going to delete an important document! Please confirm your
            login Password.
          </h1>

          <input
            type="text"
            placeholder="Password"
            className="w-full md:w-auto border border-gray-300 mt-4 px-5 py-2 focus:ring focus:ring-blue-300"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />

          <button
            className="text-lg font-bold mt-4"
            onClick={() => deleteTerritory()}
          >
            DELETE
          </button>
        </div>
      )}
      <div className="flex flex-col md:flex-row justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato">
          Territories
        </h2>
        {/* <div className="flex space-x-4">
        <div className="flex items-center mt-2 md:mt-0">
                        <label htmlFor="from-date" className="mr-2 font-lato text-black ">
                            From Date
                        </label>
                        <input
                            type="text"
                            id="from-date"
                            className="border p-2 rounded hidden"
                            value={startDate.toLocaleDateString()}
                            readOnly
                        />
                        <svg
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={toggleStartDatePicker}
                            className="ml-2 cursor-pointer"
                        >
                            <path d="M7.5 13L0.138786 0.249999L14.8612 0.25L7.5 13Z" fill="#056886" />
                        </svg>
                        {showStartDatePicker && (
                            <div
                                ref={startDatePickerRef}
                                className="absolute z-10 mt-2"
                                style={{ top: '40%', left: '70%', transform: 'translate(-50%, -50%)' }}
                            >
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => {
                                        setStartDate(date);
                                        setShowStartDatePicker(false);
                                    }}
                                    inline
                                    calendarClassName="border rounded-lg shadow-lg"
                                    dayClassName={() => "p-2 hover:bg-blue-200"}
                                    headerClassName="bg-blue-500 text-white"
                                />
                            </div>
                        )}
                    </div>
                    <div className="flex items-center mt-2 md:mt-0">
                        <label htmlFor="to-date" className="mr-2 font-lato text-black ">
                            To Date
                        </label>
                        <input
                            type="text"
                            id="to-date"
                            className="border p-2 rounded hidden"
                            value={endDate.toLocaleDateString()}
                            readOnly
                        />
                        <svg
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={toggleEndDatePicker}
                            className="ml-2 cursor-pointer"
                        >
                            <path d="M7.5 13L0.138786 0.249999L14.8612 0.25L7.5 13Z" fill="#056886" />
                        </svg>
                        {showEndDatePicker && (
                            <div
                                ref={endDatePickerRef}
                                className="absolute z-10 mt-2"
                                style={{ top: '40%', left: '90%', transform: 'translate(-50%, -50%)' }}
                            >
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => {
                                        setEndDate(date);
                                        setShowEndDatePicker(false);
                                    }}
                                    inline
                                    calendarClassName="border rounded-lg shadow-lg"
                                    dayClassName={() => "p-2 hover:bg-blue-200"}
                                    headerClassName="bg-blue-500 text-white"
                                />
                            </div>
                        )}
                    </div>
        </div> */}
      </div>

      <div className="container mx-auto bg-liquidblue p-4 mt-2 rounded-lg shadow-lg">
        <button className="bg-darkteal text-white px-8 py-2 rounded-lg font-lato font-bold self-end">
          <Link to="/territories/show" className="font-lato ">
            + ADD
          </Link>
        </button>
        <div className="">
          <div className="flex justify-end mb-4">
            <input
              type="text"
              placeholder="Search"
              className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div className="overflow-scroll h-96">
            <table className="min-w-full bg-white border overflow-scroll ">
              <thead>
                <tr className=" uppercase text-sm leading-normal">
                  <th className="py-3 px-6 text-left font-lato font-bold text-liquidblue font-2xl ">
                    Territory Name
                  </th>
                  <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">
                    Zone
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-600 text-sm font-light overflow-y-scroll">
                {filteredTerritory.map((item, index) => (
                  <tr
                    key={item.id}
                    className="border-b border-gray-200 hover:bg-gray-100 shadow-xl"
                  >
                    <td className="py-3 px-6 text-left whitespace-nowrap font-lato font-bold text-black">
                      {item.name}
                    </td>
                    <td className="py-3 px-6 text-center font-lato font-bold text-black">
                      {item.zone}
                    </td>
                    <td className="py-3 px-6 text-center">
                      <button
                        className=" border-gray-400 border rounded-sm px-4 py-1 text-gray-400 font-bold"
                        onClick={() => {
                          setDelDocIndex(index);
                          setWarning(true);
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Territories;
